function ConfiguratorGehaeuse(){
    var configurator = null;

    $configuratorFieldsetPrinzip = $(".js-fieldset_prinzip");
    $configuratorFieldsetAbmessung = $(".js-fieldset_abmessung");
    $configuratorFieldsetVentilator = $(".js-fieldset_ventilator");
    $configuratorFieldsetSchallleistung = $(".js-fieldset_schallleistung");
    $configuratorFieldsetSchallleistungGesamtwertLw = $(".js-fieldset_schallleistung_gesamtwert_lw");
    $configuratorFieldsetSchallleistungGesamtwertLp = $(".js-fieldset_schallleistung_gesamtwert_lp");
    $configuratorFieldsetOktavwerte = $(".js-fieldset_oktavwerte");

    $configuratorPrinzip = $(".js-prinzip");
    $configuratorAbmessungHoehe = $(".js-abmessung_hoehe");
    $configuratorAbmessungBreite = $(".js-abmessung_breite");
    $configuratorAbmessungTiefe = $(".js-abmessung_tiefe");

    $configuratorVentilatorEspPa = $(".js-ventilator_esp_pa");

    $configuratorSchallleistungspegel = $(".js-schallleistungspegel");
    $configuratorSchallleistungGesamtwertLw = $(".js-schallleistung_gesamtwert_lw");
    $configuratorSchallleistungGesamtwertLp = $(".js-schallleistung_gesamtwert_lp");
    $configuratorSchallleistungPegelAbstand = $(".js-schallleistung_pegel_abstand");
    $configuratorOktawerte = $(".js-oktawerte");

    $fieldsetImmissionsrichtwertLand = $(".js-fieldset_immissionsrichtwert_land");
    $immissionsrichtwertLand = $(".js-immissionsrichtwert_land");

    $fieldsetImmissionsrichtwert = $(".js-fieldset_immissionsrichtwert");
    $immissionsrichtwert = $(".js-immissionsrichtwert");
    $immissionsrichtwertHeadline = $(".js-immissionsrichtwert_headline");
    $immissionsrichtwertBeschreibung = $(".js-immissionsrichtwert_beschreibung");
    $immissionsrichtwertOptions = $immissionsrichtwert.find("option");

    $fieldsetAbstandGeraetImmissionsort = $(".js-fieldset_abstand_gereat_immissionsort");
    $abstandGeraetImmissionsort = $(".js-abstand_gereat_immissionsort");

    $configuratorFieldsetStandort = $(".js-fieldset_standort");
    $configuratorStandort = $(".js-standort");


    var $ergStandort = $(".js-erg-standort");
    var $ergGeraetAbstand = $(".js-erg-geraet-abstand");
    var $ergPrinzip = $(".js-erg-prinzip");
    var $ergHoehe = $(".js-erg-hoehe");
    var $ergBreite = $(".js-erg-breite");
    var $ergTiefe = $(".js-erg-tiefe");
    var $ergEsp = $(".js-erg-esp");
    var $ergSchallleistungspegel = $(".js-erg-schallleistungspegel");
    var $ergGesamtwert = $(".js-erg-gesamtwert");
    var $ergAbstandBlock = $(".js-erg-abstand_block");
    var $ergAbstand = $(".js-erg-abstand");
    var $ergDb31_5 = $(".js-erg-db31_5");
    var $ergDb63 = $(".js-erg-db63");
    var $ergDb125 = $(".js-erg-db125");
    var $ergDb250 = $(".js-erg-db250");
    var $ergDb500 = $(".js-erg-db500");
    var $ergDb1000 = $(".js-erg-db1000");
    var $ergDb2000 = $(".js-erg-db2000");
    var $ergDb40000 = $(".js-erg-db40000");
    var $ergDb80000 = $(".js-erg-db80000");
    var $ergDb160000 = $(".js-erg-db160000");

    var $ergZusatzLp = $(".js-zusatz_lp");
    var $ergAbstandBlockLp = $(".js-erg-abstand_block_lp");
    var $ergGesamtwertLp = $(".js-erg-gesamtwert_lp");
    var $ergAbstandLp = $(".js-erg-abstand_lp");
    var $ergDb31_5Lp = $(".js-erg-db31_5_lp");
    var $ergDb63Lp = $(".js-erg-db63_lp");
    var $ergDb125Lp = $(".js-erg-db125_lp");
    var $ergDb250Lp = $(".js-erg-db250_lp");
    var $ergDb500Lp = $(".js-erg-db500_lp");
    var $ergDb1000Lp = $(".js-erg-db1000_lp");
    var $ergDb2000Lp = $(".js-erg-db2000_lp");
    var $ergDb40000Lp = $(".js-erg-db40000_lp");
    var $ergDb80000Lp = $(".js-erg-db80000_lp");
    var $ergDb160000Lp = $(".js-erg-db160000_lp");

    this.setConfigurator = function(configurator){
        this.configurator = configurator;
    }

    $abstandGeraetImmissionsort.on("change", function(){
        $ergGeraetAbstand.text($abstandGeraetImmissionsort.find(":selected").text());
    });

    $configuratorPrinzip.on("change", function(){
        if($(".js-prinzip:checked").val() == "horizontal"){
            $configuratorVentilatorEspPa.val(15);
        }else{
            $configuratorVentilatorEspPa.val(40);
        }

        validStep2();
    });

    $configuratorAbmessungHoehe.on("keyup", function(){
        validStep2();
    });

    $configuratorAbmessungBreite.on("keyup", function(){
        validStep2();
    });

    $configuratorAbmessungTiefe.on("keyup", function(){
        validStep2();
    });

    $configuratorVentilatorEspPa.on("keyup", function(){
        validStep2();
    });

    $configuratorSchallleistungspegel.on("change", function(){
        $configuratorOktawerte.val("");
        validStep2();
    });

    $configuratorSchallleistungGesamtwertLw.on("keyup", function(){
        validStep2();
    });

    $configuratorSchallleistungGesamtwertLp.on("keyup", function(){
        validStep2();
    });

    $configuratorSchallleistungPegelAbstand.on("keyup", function(){
        validStep2();
    });

    $configuratorOktawerte.on("keyup", function(){
        validOktavwerte();
        validStep2();
    });

    this.getLpZusatzData = function(){
        return this.configurator.getDbGeraeteData();
    }

    this.showStep2 = function(){
        showPrinzip();
        validStep2();
    }

    validStep2 = function(){
        var valid = true;

        if(valid && !validPrinzip()) valid = false;
        if(valid && !validAbmessung()) valid = false;
        if(valid && !validVentilator()) valid = false;
        if(valid && !validSchallleistung()) valid = false;
        if(valid && !validOktavwerte()) valid = false;

        this.configurator.allowNextExt(valid);

        return valid;
    }

    validPrinzip = function(){
        var valid = ($(".js-prinzip:checked").val() == "horizontal" || $(".js-prinzip:checked").val() == "vertikal");
        if(valid){
            showAbmessung();
        }

        return valid;

    }

    validAbmessung = function(){
        var valid = ($configuratorAbmessungHoehe.val() != "" && $configuratorAbmessungBreite.val() != "" && $configuratorAbmessungTiefe.val() != "");

        clearFieldValidaitonClass($configuratorAbmessungHoehe);
        clearFieldValidaitonClass($configuratorAbmessungBreite);
        clearFieldValidaitonClass($configuratorAbmessungTiefe);


        if($configuratorAbmessungHoehe.val() != "" && !validIntNumberInput($configuratorAbmessungHoehe.val(), 400, 2200)){
            valid = false;
            setFieldValidaitonClass($configuratorAbmessungHoehe, valid);
        }


        if($configuratorAbmessungBreite.val() != "" && !validIntNumberInput($configuratorAbmessungBreite.val(), 400, 2200)){
            valid = false;
            setFieldValidaitonClass($configuratorAbmessungBreite, valid);
        }

        if($configuratorAbmessungTiefe.val() != "" && !validIntNumberInput($configuratorAbmessungTiefe.val(), 250, 1200)){
            valid = false;
            setFieldValidaitonClass($configuratorAbmessungTiefe, valid);
        }

        if(valid){
            showVentilator();
            $configuratorFieldsetAbmessung.find(".js-input_group").addClass("is-valid");
        }

        return valid;
    }

    validVentilator = function(){
        var valid = ($configuratorVentilatorEspPa.val() != "");

        clearFieldValidaitonClass($configuratorVentilatorEspPa);

        if($configuratorVentilatorEspPa.val() != "" && !validIntNumberInput($configuratorVentilatorEspPa.val(), 10, 100)){
            valid = false;
            setFieldValidaitonClass($configuratorVentilatorEspPa, valid);
        }

        if($configuratorVentilatorEspPa.val() != "" && $(".js-prinzip:checked").val() == "vertikal" && !validIntNumberInput($configuratorVentilatorEspPa.val(), 14, 100)){
            valid = false;
            setFieldValidaitonClass($configuratorVentilatorEspPa, valid);
        }


        if(valid){
            showSchallleistungspegel();
            $configuratorFieldsetVentilator.find(".js-input_group").addClass("is-valid");
        }

        return valid;
    }

    validSchallleistung = function(){
        var valid = true;

        if($(".js-schallleistungspegel:checked").val() == "lp"){
            showSchallleistungGesamtwertLp();
            clearFieldValidaitonClass($configuratorSchallleistungGesamtwertLp);
            clearFieldValidaitonClass($configuratorSchallleistungPegelAbstand);
            $configuratorSchallleistungGesamtwertLw.val("");
            valid = ($configuratorSchallleistungGesamtwertLp.val() != "" && $configuratorSchallleistungPegelAbstand.val() != "");

            if($configuratorSchallleistungGesamtwertLp.val() != "" && !validFloatNumberInput($configuratorSchallleistungGesamtwertLp.val(), 30.0, 100.0)){
                valid = false;
                setFieldValidaitonClass($configuratorSchallleistungGesamtwertLp, valid);
            }

            if($configuratorSchallleistungPegelAbstand.val() != "" && !validIntNumberInput($configuratorSchallleistungPegelAbstand.val(), 1, 50)){
                valid = false;
                setFieldValidaitonClass($configuratorSchallleistungPegelAbstand, valid);
            }

            if(valid){
                setFieldValidaitonClass($configuratorSchallleistungGesamtwertLp, valid);
            }
        }else if($(".js-schallleistungspegel:checked").val() == "lw"){
            showSchallleistungGesamtwertLw();

            clearFieldValidaitonClass($configuratorSchallleistungGesamtwertLw);
            $configuratorSchallleistungGesamtwertLp.val("");
            $configuratorSchallleistungPegelAbstand.val(1);
            valid = ($configuratorSchallleistungGesamtwertLw.val() != "");
            if($configuratorSchallleistungGesamtwertLw.val() != "" && !validFloatNumberInput($configuratorSchallleistungGesamtwertLw.val(), 30.0, 120.0)){
                valid = false;
                setFieldValidaitonClass($configuratorSchallleistungGesamtwertLw, valid);

            }
            if(valid){
                setFieldValidaitonClass($configuratorSchallleistungGesamtwertLw, valid);
            }
        }else{
            valid = false;
        }

        if(valid){
            showOktavwerte();
        }

        return valid;
    }


    validOktavwerte = function(){
        var valid = true;

        clearFieldValidaitonClass($configuratorOktawerte);
        $.each($configuratorOktawerte, function(key, element){
            $currentElement = $(element);

            if($currentElement.val() != "" && !validFloatNumberInput($currentElement.val(), 15.0, 120.0)){
                valid = false;
                setFieldValidaitonClass($currentElement, valid);
            }
        });

        return valid;
    }

    showPrinzip = function(){
        $configuratorFieldsetPrinzip.show();
        $configuratorFieldsetAbmessung.hide();
        $configuratorFieldsetVentilator.hide();
        $configuratorFieldsetSchallleistung.hide();
        $configuratorFieldsetSchallleistungGesamtwertLw.hide();
        $configuratorFieldsetSchallleistungGesamtwertLp.hide();
        $configuratorFieldsetOktavwerte.hide();
    }

    showAbmessung = function(){
        $configuratorFieldsetPrinzip.show();
        $configuratorFieldsetAbmessung.show();
        $configuratorFieldsetVentilator.hide();
        $configuratorFieldsetSchallleistung.hide();
        $configuratorFieldsetSchallleistungGesamtwertLw.hide();
        $configuratorFieldsetSchallleistungGesamtwertLp.hide();
        $configuratorFieldsetOktavwerte.hide();
    }

    showVentilator = function(){
        $configuratorFieldsetPrinzip.show();
        $configuratorFieldsetAbmessung.show();
        $configuratorFieldsetVentilator.show();
        $configuratorFieldsetSchallleistung.hide();
        $configuratorFieldsetSchallleistungGesamtwertLw.hide();
        $configuratorFieldsetSchallleistungGesamtwertLp.hide();
        $configuratorFieldsetOktavwerte.hide();
    }

    showSchallleistungspegel = function(){
        $configuratorFieldsetPrinzip.show();
        $configuratorFieldsetAbmessung.show();
        $configuratorFieldsetVentilator.show();
        $configuratorFieldsetSchallleistung.show();
        $configuratorFieldsetSchallleistungGesamtwertLw.hide();
        $configuratorFieldsetSchallleistungGesamtwertLp.hide();
        $configuratorFieldsetOktavwerte.hide();
    }

    showSchallleistungGesamtwertLw = function(){
        $configuratorFieldsetPrinzip.show();
        $configuratorFieldsetAbmessung.show();
        $configuratorFieldsetVentilator.show();
        $configuratorFieldsetSchallleistung.show();
        $configuratorFieldsetSchallleistungGesamtwertLw.show();
        $configuratorFieldsetSchallleistungGesamtwertLp.hide();
        $configuratorFieldsetOktavwerte.hide();
    }

    showSchallleistungGesamtwertLp = function(){
        $configuratorFieldsetPrinzip.show();
        $configuratorFieldsetAbmessung.show();
        $configuratorFieldsetVentilator.show();
        $configuratorFieldsetSchallleistung.show();
        $configuratorFieldsetSchallleistungGesamtwertLw.hide();
        $configuratorFieldsetSchallleistungGesamtwertLp.show();
        $configuratorFieldsetOktavwerte.hide();
    }

    showOktavwerte = function(){
        $configuratorFieldsetPrinzip.show();
        $configuratorFieldsetAbmessung.show();
        $configuratorFieldsetVentilator.show();
        $configuratorFieldsetSchallleistung.show();
        if($(".js-schallleistungspegel:checked").val() == "lp"){
            $configuratorFieldsetSchallleistungGesamtwertLw.hide();
            $configuratorFieldsetSchallleistungGesamtwertLp.show();
        }else{
            $configuratorFieldsetSchallleistungGesamtwertLw.show();
            $configuratorFieldsetSchallleistungGesamtwertLp.hide();
        }
        $configuratorFieldsetOktavwerte.show();
    }

    // Step 3
    $configuratorStandort.on("change", function(){
        validStep3();
    });

    $immissionsrichtwertLand.on("change", function(){
        $selected = parseInt($immissionsrichtwertLand.find(":selected").val());
        fillImmissionsrichtwerte($selected);

        landChangeMan = getLandChangeManFromConfigurator();

        if($selected > 0 && ($(".js-land").find(":selected").val() == "" || landChangeMan === false)){
            $(".js-land").val($selected)
        }

        validStep3();
    });

    getLandChangeManFromConfigurator = function(){
        return this.configurator.getLandChangeMan();
    }


    $immissionsrichtwert.on("change", function(){
        validStep3();
    });

    this.showStep3 = function(){
        validStep3();
    }

    validStep3 = function(){
        var valid = ($(".js-standort:checked").val() == "frei" || $(".js-standort:checked").val() == "fix");

        if(valid){
            $fieldsetImmissionsrichtwertLand.show();
            valid = ($fieldsetImmissionsrichtwertLand.find(":selected").val() !== "");
        }else{
            $fieldsetImmissionsrichtwertLand.hide();
        }

        $immissionsrichtwertHeadline.hide();
        $immissionsrichtwertBeschreibung.hide();
        $fieldsetAbstandGeraetImmissionsort.hide();

        if(valid) fillImmissionsrichtwertBeschreibung();

        if(valid && hx.is_numeric($fieldsetImmissionsrichtwertLand.find(":selected").val())){
            showImmissionsrichtwert(true);
            valid = false;
            valid = ($fieldsetImmissionsrichtwert.find(":selected").val() != "-1")
            if(valid){
                $immissionsrichtwertHeadline.show();
                $immissionsrichtwertBeschreibung.show();
            }
        }else{
            showImmissionsrichtwert(false);
            showAbstandGeraetImmissionsort(false);
        }

        if(valid && hx.is_numeric($fieldsetImmissionsrichtwert.find(":selected").val())){
            showAbstandGeraetImmissionsort(true);
        }else{
            showAbstandGeraetImmissionsort(false);
        }

        this.configurator.allowNextExt(valid);
    }

    showImmissionsrichtwert = function(show){
        if(show){
            $fieldsetImmissionsrichtwert.show();
        }else{
            $fieldsetImmissionsrichtwert.hide();
        }
    }

    showAbstandGeraetImmissionsort = function(show){
        if(show){
            $fieldsetAbstandGeraetImmissionsort.show();
            $ergGeraetAbstand.text($abstandGeraetImmissionsort.find(":selected").text());
        }else{
            $fieldsetAbstandGeraetImmissionsort.hide();
        }
    }

    fillImmissionsrichtwerte = function(idLand){
        $immissionsrichtwert.html("");
        $immissionsrichtwertOptions.each(function(key, option){
            $option = $(option)
            if($option.val() == "-1") $option.prop("selected", true).appendTo($immissionsrichtwert);
            if($option.data("land") == idLand) $option.prop("selected", false).appendTo($immissionsrichtwert);
        })
        $immissionsrichtwert.val("-1");
    }

    fillImmissionsrichtwertBeschreibung = function(){
        var headline = $immissionsrichtwertLand.find(":selected").data("headline");
        var beschreibung = $immissionsrichtwert.find(":selected").data("beschreibung");
        $immissionsrichtwertHeadline.html(headline);
        $immissionsrichtwertBeschreibung.html(beschreibung);
    }

    this.fillErgData = function(){
        if($(".js-standort:checked").val() == "frei"){
            $ergStandort.text($configuratorFieldsetStandort.data("frei"));
        }else if($(".js-standort:checked").val() == "fix"){
            $ergStandort.text($configuratorFieldsetStandort.data("fix"));
        }

        if($(".js-prinzip:checked").val() == "horizontal"){
            $ergPrinzip.text($configuratorFieldsetPrinzip.data("horizontal"));
        }else if($(".js-prinzip:checked").val() == "vertikal"){
            $ergPrinzip.text($configuratorFieldsetPrinzip.data("vertikal"));
        }

        $ergHoehe.text($configuratorAbmessungHoehe.val());
        $ergBreite.text($configuratorAbmessungBreite.val());
        $ergTiefe.text($configuratorAbmessungTiefe.val());
        $ergEsp.text($configuratorVentilatorEspPa.val());

        $.each($ergZusatzLp, function(key, element){
          $(element).hide();
        });

        if($(".js-schallleistungspegel:checked").val() == "lw"){
            $ergSchallleistungspegel.text($configuratorFieldsetSchallleistung.data("lw"));
            $ergGesamtwert.text($configuratorSchallleistungGesamtwertLw.val());
            $ergAbstandBlock.hide();

            lpZusatz = this.configurator.getDbGeraeteData();
            if(lpZusatz.schallleistung_gesamtwert_lp != undefined  && lpZusatz.schallleistung_gesamtwert_lp !== "0" && lpZusatz.pegel_abstand_lp !== "0"){
                $ergGesamtwertLp.text(lpZusatz.schallleistung_gesamtwert_lp);
                $ergAbstandLp.text(lpZusatz.pegel_abstand_lp);

                $.each($ergZusatzLp, function(key, element){
                    $(element).show();
                });

                $ergDb31_5Lp.text(lpZusatz.octawert_31_5_lp);
                $ergDb63Lp.text(lpZusatz.octawert_63_lp);
                $ergDb125Lp.text(lpZusatz.octawert_125_lp);
                $ergDb250Lp.text(lpZusatz.octawert_250_lp);
                $ergDb500Lp.text(lpZusatz.octawert_500_lp);
                $ergDb1000Lp.text(lpZusatz.octawert_1000_lp);
                $ergDb2000Lp.text(lpZusatz.octawert_2000_lp);
                $ergDb40000Lp.text(lpZusatz.octawert_4000_lp);
                $ergDb80000Lp.text(lpZusatz.octawert_8000_lp);
                $ergDb160000Lp.text(lpZusatz.octawert_16000_lp);
            }
        }else if($(".js-schallleistungspegel:checked").val() == "lp"){
            $ergSchallleistungspegel.text($configuratorFieldsetSchallleistung.data("lp"));
            $ergGesamtwert.text($configuratorSchallleistungGesamtwertLp.val());
            $ergAbstand.text($configuratorSchallleistungPegelAbstand.val());
            $ergAbstandBlock.show();
        }

        $configuratorOktawerte.each(function(key, element){
            var $currentElement = $(element);
            if(key == 0){
                var wert = $currentElement.val();
                $ergDb31_5.text(wert);
            }else if(key == 1){
                var wert = $currentElement.val();
                $ergDb63.text(wert);
            }else if(key == 2){
                var wert = $currentElement.val();
                $ergDb125.text(wert);
            }else if(key == 3){
                var wert = $currentElement.val();
                $ergDb250.text(wert);
            }else if(key == 4){
                var wert = $currentElement.val();
                $ergDb500.text(wert);
            }else if(key == 5){
                var wert = $currentElement.val();
                $ergDb1000.text(wert);
            }else if(key == 6){
                var wert = $currentElement.val();
                $ergDb2000.text(wert);
            }else if(key == 7){
                var wert = $currentElement.val();
                $ergDb40000.text(wert);
            }else if(key == 8){
                var wert = $currentElement.val();
                $ergDb80000.text(wert);
            }else if(key == 9){
                var wert = $currentElement.val();
                $ergDb160000.text(wert);
            }
        });
    }
}